<template>
	<div  class="container">
		<triangle-image
			title="Chi siamo"
			subtitle="Amiamo condividere la nostra passione per un'alimentazione sana e gustosa"
		>
		</triangle-image>

		<div>
			<div class="content">
				<section class="flex-vcenter">
					<usp :template="'team'">
						<template slot="titles">
							<h2 class="center">{{ $t("components.usp.team.title") }}</h2>
						</template>
					</usp>
				</section>

				<section>
					<div class="flex-center center">
						<div>
							<h2 class="center">Il team Quomi</h2>
							<p>Quomi nasce nel 2016, quando Andrea e Daniele scoprono che hanno un problema: mangiano sempre le stesse ricette e non hanno mai tempo di fare la spesa! Si chiedono quindi: perché non risolvere questo problema a tutte le persone che come noi vogliono mangiare nuove ricette sfiziose ogni settimana e spedir loro tutto ciò che serve per prepararle? Detto, fatto!<br><br></p>
						</div>

						<div class="flex-center row team">
							<div class="col-xs-6 col-sm-6 col-md-4 center" v-for="(person, index) in team" :key="index">
								<div class="img-container">
									<img :src="require('../../assets/img/team/' + person.img)" :alt="person.name">
									<img class="hover" :src="require('../../assets/img/team/' + person.img_)" :alt="person.name">
								</div>

								<h6 class="team-name">{{ person.name }}</h6>
								<div class="title-container">
									<div class="team-title">{{ person.title }}</div>

									<div class="team-title hover" :class="{ me: person.me }">{{ person.title_ }}</div>
								</div>

								<p v-if="person.recipe.name"><i class="fas fa-utensils" /> Piatto preferito:
									<span v-if="person.recipe.link">
										<router-link :to="{ path: '/ricetta/' + person.recipe.link }" class="link-detail">{{ person.recipe.name }}</router-link>
									</span>
									<span v-else>{{ person.recipe.name }}</span>
								</p>
							</div>
						</div>
					</div>
				</section>

			</div>
		</div>

		<start-with-us />

		<section class='section-logos press-kit'>

			<h2 class="center">Scarica il nostro Press Kit</h2>
			<div class='container-logos center'>
				<a href="../../static/Press-Kit-Quomi-2020.zip" download class="flex-center">
					<CTA
						:content="`Press Kit Quomi 2020 <i class='fa fa-download' />`"
					/>
				</a>
			</div>

		</section>

	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'
import StartWithUs from '../Parts/StartWithUs'
import Usp from '../Usp'

import { team } from '../../data/team'
export default {
	components: {
		'triangle-image': TriangleImage,
		'start-with-us': StartWithUs,
		'usp': Usp
	},

	data () {
		return {
			team: team
		}
	}
}

</script>

<style scoped>

	.triangle-image {
		background: url("../../assets/img/covers/quomi-team.jpg") center 55% no-repeat;
		min-height: 700px;
	}

	.triangle-image {
		filter: opacity(80%);
	}

	section + section {
		padding-top: 30px;
	}

	@media (max-width: 1024px) {
		* >>> .triangle-image p {
			display: none;
		}
	}

	@media (max-width: 992px) {
		.triangle-image {
			background-image: url("https://api.quomi.it/oldimg/quomi-team.webp") center 85% no-repeat;
			background-size: cover;
			padding: 0 !important;
			min-height: 325px;
		}

		.triangle-image .triangle-image-body {
			color: red;
		}
	}

	.team-name {
		margin: 5px 0 0px 0;
		text-transform: uppercase;
		font-weight: bold;
	}

	.press-kit {
		background-color: #fff !important;
	}

	.row.team::before, .row.team::after {
		display: none;
	}

	.row.team {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		max-width: 1000px;
		align-items: flex-start;
		padding: 0 25px;
	}

	.row.team > div {
		margin-bottom: 10px;
		padding: 0 25px;
	}

	.row.team .img-container {
		position: relative;
		padding-bottom: 5px;
	}

	.row.team img.hover {
		display: none;
	}

	.row.team .img-container:hover img.hover {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
	}

	.row.team .title-container {
		position: relative;
	}

	.team-title {
		padding-bottom: 5px;
	}

	.row.team .team-title.hover {
		display: none;
	}

	.row.team .img-container:hover ~ .title-container .team-title.hover {
		display: block;
	}

	.row.team .img-container:hover ~ .title-container .team-title {
		display: none;
	}

	.section-logos {
		background-color: #ededed;
		padding: 30px 0px;
	}

	.fa-download {
		vertical-align: middle;
	}

	.col-sm-6 {
		flex: 0 0 50%;
	}

</style>
